import React, { useEffect, useState } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import useDashboardContext from 'contexts/dashboard.context';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import FormStepper from 'components/base/form-stepper';
import RequestConversionListDetails from './request-manage-meals-details';
import useBrandChefsContext from 'contexts/brand-chefs.context';
import ReviewMealsDetails from './review-manage-meals-details';
import { apiService } from 'services/base.service';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const RequestConversionList = () => {
  const { setIsBackLink, setBackLinkTitle, setBackLink } = useDashboardContext();
  const [isCreatingVendors, setIsCreatingVendors] = useState(false);
  const { step, setStep, itemToEdit, setItemToEdit } = useBrandChefsContext();
  const router = useNavigate();
  const { activeStore } = useDashboardContext();

  function isStepEmpty(data: any): boolean {
    for (const item of data) {
      for (const key in item) {
        if ((key === 'request_portion' || key === 'ingredient_id') && !item[key]) {
          return true;
        }
      }
    }
    return false;
  }

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to vendors');
    setBackLink(MAIN_STORE_ROUTE_KEYS.VENDORS);
    return () => {
      setIsBackLink(false);
    };
  }, []);

  const requestItems = async () => {
    if (!activeStore) return;
    const data = {
      items: itemToEdit?.map((vendorDataToUpload) => {
        return {
          mix_id: vendorDataToUpload?.id,
          quantity_requested: Number(vendorDataToUpload?.request_portion),
          item_type: vendorDataToUpload?.item_type
        };
      }),
      store_id: activeStore.id,
      item_type: 'meal',
      note: '.'
    };
    try {
      setIsCreatingVendors(true);
      const res = await apiService.post(`prep-kitchen-request`, {
        data,
        version: 'v2'
      });
      if (res) {
        router(-1);
        setItemToEdit([]);
        toast(<ToastMessage message='Meal items requested successfully' type='success' />);
      }
    } catch (err: any) {
      toast(<ToastMessage message={'Error requesting meal items'} type='error' />);
    } finally {
      setIsCreatingVendors(false);
    }
  };
  const isDisabled = step === 1 ? isStepEmpty(itemToEdit) : !!isStepEmpty(itemToEdit);

  return (
    <div>
      <PageHeaderText
        title='New request'
        description='Need items from the kitchen? prepare your list '
      />
      <div className='max-w-[678px]'>
        <FormStepper
          disabled={isDisabled}
          title=''
          step={step}
          handleConfirmClick={() => requestItems()}
          handleCancelClick={() => {
            if (step === 1) {
              router(MAIN_STORE_ROUTE_KEYS.MANAGE_MEALS);
            }
          }}
          setStep={setStep}
          noOfSteps={2}
          loading={isCreatingVendors}>
          <div>{step === 1 ? <RequestConversionListDetails /> : <ReviewMealsDetails />}</div>
        </FormStepper>
      </div>
    </div>
  );
};

export default RequestConversionList;
